import {action, observable} from 'mobx';

declare const window: any;

export enum ABTestKeys {
    product_glass = 'product_glass',
    ab_checkout_1 = 'ab_checkout_1',
    product_mats = 'product_mats',
    product_gray_box = 'product_gray_box',
    prod_zoom = 'prod_zoom',
    ab_green_store = 'ab_green_store',
    ab_green_product = 'ab_green_product',
    ab_store_filters = 'ab_store_filters',
    ab_prod_th6 = 'ab_prod_th6',
    prod_buynow = 'prod_buynow',
    caf_single = 'caf_single',
    prod_shipping = 'prod_shipping',
}

export class AbTestStore {
    @observable ab: any;

    constructor() {
        this.ab = {};
    }

    abForceUpdate = async (_component: React.Component) => _component.forceUpdate();

    @action
    HasKey = (key: string): boolean => {
        if (!window.ab) {
            return false;
        } else if (window.ab[key] === undefined) {
            return false;
        } else if (!this.ab) {
            return false;
        } else if (this.ab[key] === undefined) {
            return false;
        }
        return true;
    };

    @action
    ABIsVariant = (key: string, variation: number): boolean => {
        if (!window.ab) {
            return false;
        } else if (window.ab[key] === undefined) {
            return false;
        } else if (!this.ab) {
            return false;
        } else if (this.ab[key] === undefined) {
            return false;
        }

        return window.ab[key] === variation && this.ab && this.ab[key] === variation;
    };

    @action
    ABGetValue = (key: string): number => {
        if (!window.ab) {
            return 0;
        } else if (window.ab[key] === undefined) {
            return 0;
        } else if (!this.ab) {
            return 0;
        } else if (this.ab[key] === undefined) {
            return 0;
        }

        return this.ab[key];
    };

    @action
    ABGetClassName = (key: string): string => {
        if (this.ABGetValue(key) === 0) {
            return '';
        }

        return `ab-${this.ABGetValue(key)} `;
    };
}

export default new AbTestStore();
